import { Pipe, PipeTransform } from '@angular/core';
import { Subject } from 'rxjs';
import { UtilsService } from 'src/app/core/service/utils.service';

enum ValidateType {
  NUMBER = 'number',
  INTEGER = 'integer',
  DECIMAL = 'decimal',
  POSITIVE = 'positive',
  DATE = 'date'
}

@Pipe({
  name: 'xValidate'
})
export class XValidatePipe implements PipeTransform {

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(protected utilSrv: UtilsService) {
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  transform(event: any, ...args: any[]): any {
    if (args.find(a => a === ValidateType.NUMBER)) {
      return this.validateNumbers(event, args);
    } else if (args.find(a => a === ValidateType.DATE)) {
      return event.charCode >= 48 && event.charCode <= 57 || event.charCode === 47;
    } else return null;
  }

  validateNumbers(event: any, args: any[]) {
    if (args.find(a => a === ValidateType.POSITIVE)) {
      if (args.find(a => a === ValidateType.INTEGER)) {
        return this.validatePositiveIntegerNumbers(event);
      } else if (args.find(a => a === ValidateType.DECIMAL)) {
        return this.validatePositiveDecimalNumbers(event);
      } else return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ?
        false :
        event.charCode >= 48 && event.charCode <= 57 || (event.charCode === 44 || event.charCode === 46);
    } else return event.charCode >= 48 && event.charCode <= 57 || (event.charCode === 44 || event.charCode === 46);
  }

  validatePositiveIntegerNumbers(event: any) {
    const value = event.target.value;
    const min = parseInt(event.target.min);
    const max = parseInt(event.target.max);
    const valueNow = parseFloat(value?.toString() + event.key);
    if (min && valueNow && valueNow < min) return false;
    if (max && valueNow && valueNow > max) return false;
    return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57
  }

  validatePositiveDecimalNumbers(event: any) {
    const value = event.target.value;
    const min = parseInt(event.target.min);
    const max = parseInt(event.target.max);
    const valueNow = parseFloat(value?.toString() + event.key);
    if (min && valueNow && valueNow < min) return false;
    if (max && valueNow && valueNow > max) return false;
    return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? false : event.charCode >= 48 && event.charCode <= 57 || (event.charCode === 44 || event.charCode === 46)
  }

}
